/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiDistrictCreateDistrictPost } from '../fn/district/api-district-create-district-post';
import { ApiDistrictCreateDistrictPost$Params } from '../fn/district/api-district-create-district-post';
import { apiDistrictCreateDistrictPost$Plain } from '../fn/district/api-district-create-district-post-plain';
import { ApiDistrictCreateDistrictPost$Plain$Params } from '../fn/district/api-district-create-district-post-plain';
import { apiDistrictDeleteDistrictDelete } from '../fn/district/api-district-delete-district-delete';
import { ApiDistrictDeleteDistrictDelete$Params } from '../fn/district/api-district-delete-district-delete';
import { apiDistrictDeleteDistrictDelete$Plain } from '../fn/district/api-district-delete-district-delete-plain';
import { ApiDistrictDeleteDistrictDelete$Plain$Params } from '../fn/district/api-district-delete-district-delete-plain';
import { apiDistrictGetDistrictGet } from '../fn/district/api-district-get-district-get';
import { ApiDistrictGetDistrictGet$Params } from '../fn/district/api-district-get-district-get';
import { apiDistrictGetDistrictGet$Plain } from '../fn/district/api-district-get-district-get-plain';
import { ApiDistrictGetDistrictGet$Plain$Params } from '../fn/district/api-district-get-district-get-plain';
import { apiDistrictGetDistrictsGet } from '../fn/district/api-district-get-districts-get';
import { ApiDistrictGetDistrictsGet$Params } from '../fn/district/api-district-get-districts-get';
import { apiDistrictGetDistrictsGet$Plain } from '../fn/district/api-district-get-districts-get-plain';
import { ApiDistrictGetDistrictsGet$Plain$Params } from '../fn/district/api-district-get-districts-get-plain';
import { apiDistrictUpdateDistrictPatch } from '../fn/district/api-district-update-district-patch';
import { ApiDistrictUpdateDistrictPatch$Params } from '../fn/district/api-district-update-district-patch';
import { apiDistrictUpdateDistrictPatch$Plain } from '../fn/district/api-district-update-district-patch-plain';
import { ApiDistrictUpdateDistrictPatch$Plain$Params } from '../fn/district/api-district-update-district-patch-plain';
import { CreateDistrictCommandResult } from '../models/create-district-command-result';
import { DeleteDistrictCommandResult } from '../models/delete-district-command-result';
import { GetAllDistrictsQueryResult } from '../models/get-all-districts-query-result';
import { GetDistrictQueryResult } from '../models/get-district-query-result';
import { UpdateDistrictCommandResult } from '../models/update-district-command-result';

@Injectable({ providedIn: 'root' })
export class DistrictService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDistrictGetDistrictGet()` */
  static readonly ApiDistrictGetDistrictGetPath = '/api/District/GetDistrict';

  /**
   * Get details of a specific district by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictGetDistrictGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictGet$Plain$Response(params?: ApiDistrictGetDistrictGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDistrictQueryResult>> {
    return apiDistrictGetDistrictGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get details of a specific district by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictGetDistrictGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictGet$Plain(params?: ApiDistrictGetDistrictGet$Plain$Params, context?: HttpContext): Observable<GetDistrictQueryResult> {
    return this.apiDistrictGetDistrictGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDistrictQueryResult>): GetDistrictQueryResult => r.body)
    );
  }

  /**
   * Get details of a specific district by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictGetDistrictGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictGet$Response(params?: ApiDistrictGetDistrictGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDistrictQueryResult>> {
    return apiDistrictGetDistrictGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get details of a specific district by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictGetDistrictGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictGet(params?: ApiDistrictGetDistrictGet$Params, context?: HttpContext): Observable<GetDistrictQueryResult> {
    return this.apiDistrictGetDistrictGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDistrictQueryResult>): GetDistrictQueryResult => r.body)
    );
  }

  /** Path part for operation `apiDistrictGetDistrictsGet()` */
  static readonly ApiDistrictGetDistrictsGetPath = '/api/District/GetDistricts';

  /**
   * Get all districts with pagination and filtering options.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictGetDistrictsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictsGet$Plain$Response(params?: ApiDistrictGetDistrictsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllDistrictsQueryResult>> {
    return apiDistrictGetDistrictsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all districts with pagination and filtering options.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictGetDistrictsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictsGet$Plain(params?: ApiDistrictGetDistrictsGet$Plain$Params, context?: HttpContext): Observable<GetAllDistrictsQueryResult> {
    return this.apiDistrictGetDistrictsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllDistrictsQueryResult>): GetAllDistrictsQueryResult => r.body)
    );
  }

  /**
   * Get all districts with pagination and filtering options.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictGetDistrictsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictsGet$Response(params?: ApiDistrictGetDistrictsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllDistrictsQueryResult>> {
    return apiDistrictGetDistrictsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all districts with pagination and filtering options.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictGetDistrictsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDistrictGetDistrictsGet(params?: ApiDistrictGetDistrictsGet$Params, context?: HttpContext): Observable<GetAllDistrictsQueryResult> {
    return this.apiDistrictGetDistrictsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllDistrictsQueryResult>): GetAllDistrictsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiDistrictCreateDistrictPost()` */
  static readonly ApiDistrictCreateDistrictPostPath = '/api/District/CreateDistrict';

  /**
   * Create a new district.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictCreateDistrictPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictCreateDistrictPost$Plain$Response(params?: ApiDistrictCreateDistrictPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateDistrictCommandResult>> {
    return apiDistrictCreateDistrictPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new district.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictCreateDistrictPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictCreateDistrictPost$Plain(params?: ApiDistrictCreateDistrictPost$Plain$Params, context?: HttpContext): Observable<CreateDistrictCommandResult> {
    return this.apiDistrictCreateDistrictPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateDistrictCommandResult>): CreateDistrictCommandResult => r.body)
    );
  }

  /**
   * Create a new district.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictCreateDistrictPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictCreateDistrictPost$Response(params?: ApiDistrictCreateDistrictPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateDistrictCommandResult>> {
    return apiDistrictCreateDistrictPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new district.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictCreateDistrictPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictCreateDistrictPost(params?: ApiDistrictCreateDistrictPost$Params, context?: HttpContext): Observable<CreateDistrictCommandResult> {
    return this.apiDistrictCreateDistrictPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateDistrictCommandResult>): CreateDistrictCommandResult => r.body)
    );
  }

  /** Path part for operation `apiDistrictUpdateDistrictPatch()` */
  static readonly ApiDistrictUpdateDistrictPatchPath = '/api/District/UpdateDistrict';

  /**
   * Update an existing district.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictUpdateDistrictPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictUpdateDistrictPatch$Plain$Response(params?: ApiDistrictUpdateDistrictPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateDistrictCommandResult>> {
    return apiDistrictUpdateDistrictPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing district.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictUpdateDistrictPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictUpdateDistrictPatch$Plain(params?: ApiDistrictUpdateDistrictPatch$Plain$Params, context?: HttpContext): Observable<UpdateDistrictCommandResult> {
    return this.apiDistrictUpdateDistrictPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateDistrictCommandResult>): UpdateDistrictCommandResult => r.body)
    );
  }

  /**
   * Update an existing district.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictUpdateDistrictPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictUpdateDistrictPatch$Response(params?: ApiDistrictUpdateDistrictPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateDistrictCommandResult>> {
    return apiDistrictUpdateDistrictPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing district.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictUpdateDistrictPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictUpdateDistrictPatch(params?: ApiDistrictUpdateDistrictPatch$Params, context?: HttpContext): Observable<UpdateDistrictCommandResult> {
    return this.apiDistrictUpdateDistrictPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateDistrictCommandResult>): UpdateDistrictCommandResult => r.body)
    );
  }

  /** Path part for operation `apiDistrictDeleteDistrictDelete()` */
  static readonly ApiDistrictDeleteDistrictDeletePath = '/api/District/DeleteDistrict';

  /**
   * Delete a district by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictDeleteDistrictDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictDeleteDistrictDelete$Plain$Response(params?: ApiDistrictDeleteDistrictDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteDistrictCommandResult>> {
    return apiDistrictDeleteDistrictDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a district by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictDeleteDistrictDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictDeleteDistrictDelete$Plain(params?: ApiDistrictDeleteDistrictDelete$Plain$Params, context?: HttpContext): Observable<DeleteDistrictCommandResult> {
    return this.apiDistrictDeleteDistrictDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteDistrictCommandResult>): DeleteDistrictCommandResult => r.body)
    );
  }

  /**
   * Delete a district by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDistrictDeleteDistrictDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictDeleteDistrictDelete$Response(params?: ApiDistrictDeleteDistrictDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteDistrictCommandResult>> {
    return apiDistrictDeleteDistrictDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a district by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDistrictDeleteDistrictDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDistrictDeleteDistrictDelete(params?: ApiDistrictDeleteDistrictDelete$Params, context?: HttpContext): Observable<DeleteDistrictCommandResult> {
    return this.apiDistrictDeleteDistrictDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteDistrictCommandResult>): DeleteDistrictCommandResult => r.body)
    );
  }

}
